import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { AiReveniIcon, Divider, InputWithLabel, ReveniAiButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const AiImprovementInput = ({ value, onChange, onGenerate, generating }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Divider />
      <Styles.ImprovementInputContainer>
        <Styles.LabelContainer>
          <AiReveniIcon size={20} color={theme.colors.ai.hover} />
          <Text type="bodyMRegular" color={theme.colors.ai.hover}>
            {t('¿Cómo puedo ayudarte?')}
          </Text>
        </Styles.LabelContainer>
        <InputWithLabel fullWidth placeholder={t('¿Qué te gustaría mejorar?')} value={value} onChange={onChange} />
        <ReveniAiButton
          label={t('Generar')}
          onClick={onGenerate}
          loading={generating}
          disabled={!value?.trim() || generating}
        />
      </Styles.ImprovementInputContainer>
    </Styles.Container>
  )
}

export default AiImprovementInput
